<template>
    <div>
      <div class="d-flex align-items-center mb-3">
        <select v-model="statusFilter" v-on:change="loadData" class="form-control" style="max-width: 220px;">
          <option value="">Semua Status</option>
          <option value="pending">Menunggu Pembayaran</option>
          <option value="paid">Lunas</option>
          <option value="expired">Kedaluwarsa</option>
          <option value="cancelled">Dibatalkan</option>
        </select>
      </div>
      <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
        :totalRows="table.total_records" :isLoading.sync="table.isLoading" :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            perPageDropdown: [10, 25, 50, 100],
          }" :columns="table.columns" :rows="table.rows">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'created_at'">
            {{ formatDate(props.row.created_at) }}
          </span>
          <span v-else-if="props.column.field == 'user'">
            {{ props.row.user ? props.row.user.name : props.row.user_id }}
          </span>
          <span v-else-if="props.column.field == 'package_name'">
            {{ props.row.package ? props.row.package.name : '-' }}
          </span>
          <span v-else-if="props.column.field == 'amount'">
            <div v-if="props.row.amount_idr && props.row.amount_idr > 0">
              {{ formatRupiah(props.row.amount_idr) }}
            </div>
            <div v-else class="text-muted">${{ props.row.amount }}</div>
          </span>
          <span v-else-if="props.column.field == 'payment_method'">
            <span v-if="props.row.payment_method == 'transfer'" class="badge badge-info">
              <i class="fas fa-university mr-1"></i> Transfer Bank
            </span>
            <span v-else-if="props.row.payment_method == 'paypal'" class="badge badge-primary">
              <i class="fab fa-paypal mr-1"></i> PayPal
            </span>
            <span v-else class="badge badge-secondary">-</span>
          </span>
          <span v-else-if="props.column.field == 'status'">
            <span v-if="props.row.status == 'paid'" class="badge badge-success">Lunas</span>
            <span v-else-if="props.row.status == 'pending'" class="badge badge-warning text-white">Menunggu Pembayaran</span>
            <span v-else-if="props.row.status == 'expired'" class="badge badge-secondary">Kedaluwarsa</span>
            <span v-else-if="props.row.status == 'cancelled'" class="badge badge-danger">Dibatalkan</span>
            <span v-else class="badge badge-secondary">{{ props.row.status }}</span>
          </span>
          <span v-else-if="props.column.field == 'action'">
            <a v-if="props.row.status == 'pending' && props.row.payment_method == 'transfer'"
              v-on:click="confirmPayment(props.row)" class="btn btn-success btn-sm text-white margin5">
              <i class="fas fa-check mr-1"></i> Konfirmasi Pembayaran
            </a>
            <span v-else-if="props.row.status == 'paid'" class="text-success">
              <i class="fas fa-check-circle"></i>
            </span>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data() {
      return {
        statusFilter: '',
        table: {
          total_records: 0,
          isLoading: true,
          columns: [{
              label: "Tanggal",
              field: "created_at",
              sortable: false,
            },
            {
              label: "No. Invoice",
              field: "invoice_number",
              filterOptions: {
                enabled: true,
                placeholder: "Cari no. invoice",
                trigger: 'enter',
              },
              sortable: false,
            },
            {
              label: "User",
              field: "user",
              sortable: false,
            },
            {
              label: "Paket",
              field: "package_name",
              sortable: false,
            },
            {
              label: "Nominal",
              field: "amount",
              sortable: false,
            },
            {
              label: "Metode",
              field: "payment_method",
              sortable: false,
            },
            {
              label: "Status",
              field: "status",
              sortable: false,
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
            },
          ],
          rows: [],
          params: {
            page: 1,
            limit: 10,
            invoice_number: '',
          },
        },
      };
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fnRefreshTable);
    },
    mounted() {
      this.fnRefreshTable = () => {
        this.loadData();
      }
      this.$root.$on("refresh_table", this.fnRefreshTable);
      this.loadData();
    },
    methods: {
      async loadData() {
        this.table.isLoading = true;
        try {
          let params = {
            page: this.table.params.page,
            limit: this.table.params.limit,
          };
          if (this.statusFilter) params.status = this.statusFilter;
          if (this.table.params.invoice_number) params.invoice_number = this.table.params.invoice_number;

          let response = await this.$store.dispatch('admin_transactions_list', params);
          this.table.rows = response.data.data.invoices || [];
          this.table.total_records = response.data.data.total_records || 0;
        } catch (err) {
          this.$toast.error(err.response?.data?.message || "Gagal memuat transaksi");
        } finally {
          this.table.isLoading = false;
        }
      },
      formatDate(date) {
        if (!date) return '-'
        return moment(date).format('DD MMM YYYY HH:mm')
      },
      formatRupiah(numb) {
        if (!numb && numb !== 0) return '-'
        const format = numb.toString().split('').reverse().join('');
        const convert = format.match(/\d{1,3}/g);
        const rupiah = 'Rp ' + convert.join('.').split('').reverse().join('')
        return rupiah
      },
      async confirmPayment(row) {
        const pkgName = row.package ? row.package.name : 'paket';
        if (confirm(`Konfirmasi pembayaran invoice ${row.invoice_number} (${pkgName})? Paket user akan langsung diaktifkan/diperpanjang.`)) {
          try {
            let response = await this.$store.dispatch('admin_invoice_mark_paid', { id: row.id });
            this.$toast.success(response.data.message || 'Pembayaran dikonfirmasi, paket diaktifkan');
            this.loadData();
          } catch (err) {
            this.$toast.error(err.response?.data?.message || 'Gagal konfirmasi pembayaran');
          }
        }
      },
      onPageChange(params) {
        this.table.params.page = params.currentPage;
        this.loadData();
      },
      onPerPageChange(params) {
        this.table.params.limit = params.currentPerPage;
        this.loadData();
      },
      onColumnFilter(params) {
        this.table.params.invoice_number = params.invoice_number || '';
        this.loadData();
      },
    },
  };
</script>

<style scoped>
  .margin5 {
    margin: 5px;
  }
</style>
